import { gql } from '@apollo/client'

const MARK_INVOICE_PAID = gql`
  mutation MarkInvoicePaid($storeOrderId: String) {
    markInvoicePaid(storeOrderId: $storeOrderId) {
      id
    }
  }
`

export default MARK_INVOICE_PAID
